// Tiny DOM helper. el("div.card", { onclick: fn }, "text", childNode)
export function el(selector, props = {}, ...children) {
	const [tag, ...classes] = parseSelector(selector);
	const node = document.createElement(tag);
	for (const cls of classes) node.classList.add(cls);

	for (const [key, value] of Object.entries(props)) {
		if (value == null || value === false) continue;
		if (key === "class") {
			for (const c of String(value).split(/\s+/).filter(Boolean)) {
				node.classList.add(c);
			}
		} else if (key === "style" && typeof value === "object") {
			Object.assign(node.style, value);
		} else if (key === "dataset" && typeof value === "object") {
			Object.assign(node.dataset, value);
		} else if (key.startsWith("on") && typeof value === "function") {
			node.addEventListener(key.slice(2).toLowerCase(), value);
		} else if (key in node && isWritable(node, key)) {
			node[key] = value;
		} else {
			node.setAttribute(key, value);
		}
	}

	for (const child of children.flat()) {
		if (child == null || child === false) continue;
		node.append(child instanceof Node ? child : String(child));
	}
	return node;
}

// Some reflected props are getter-only (input.list, input.form): assigning one
// throws, so those go through setAttribute instead.
function isWritable(node, key) {
	for (let o = node; o; o = Object.getPrototypeOf(o)) {
		const d = Object.getOwnPropertyDescriptor(o, key);
		if (d) return d.writable || typeof d.set === "function";
	}
	return true;
}

function parseSelector(selector) {
	const parts = selector.split(".");
	return [parts[0] || "div", ...parts.slice(1)];
}

export function clear(node) {
	while (node.firstChild) node.removeChild(node.firstChild);
}
